



















































































export default

	props:
		traceData: Object

	data: ->
		global: false
		isFlavored: false
		current: 'profile'
		product: []


	mounted: ->

		@traceData.countries.forEach (country) =>
			if country.COOCountry != 'United States'
				global = true

		# determine if the product is the new flavored variant
		title = @traceData.ItemDesc
		console.log title
		if title.includes "Garlic" then @isFlavored = true
		if title.includes "Jalapeno" then @isFlavored = true
		if title.includes "Truffle" then @isFlavored = true

		@$wait 100, =>
			@setNav '#profile'

	computed:

		sections: ->
			if !@isFlavored then [
					{
						label: 'Profile'
						id: '#profile'
					},
					{
						label: 'Origins'
						id: '#origins'
					},
					{
						label: 'Healthy Phenols'
						id: '#phenols'
					},
					{
						label: 'Certification & Testing'
						id: '#certification'
					},
					{
						label: 'How it\'s Made'
						id: '#how-its-made'
					}
				]
			else [
				{
					label: 'Profile'
					id: '#profile'
				},
				{
					label: 'Origins'
					id: '#origins'
				},
				{
					label: 'About & Certification'
					id: '#about'
				},
				{
					label: 'How it\'s Made'
					id: '#how-its-made'
				}
			]


		contentMap: ->
			title = @traceData.ItemDesc

			# "COR Rstd Garlic EVOO Chef's Btl 6/250ml cs" - garlic squeeze
			# "COR Rstd Garlic EVOO Blend 6/750mL cs" - garlic glass
			# "COR Jalapeno Herb EVOO Chef’s Btl 6/250mL cs" - jalapeno
			# "COR Black Truffle EVOO Chef's Btl 6/250ml cs" - truffle

			# Garlic Squeeze
			if title.includes "Garlic EVOO Chef"
				return {
					title: 'Garlic Flavored EVOO'
					flavored: true
					about: 'about-this-oil-flavored-garlic-evoo-chefs-bottle-250ml'
					qa: 'qa-flavored-garlic-evoo-chefs-bottle-250ml'
					sustainability: 'sustainability-flavored-garlic-evoo-chefs-bottle-250ml'
					recipe: 'recipe-flavored-garlic-evoo-chefs-bottle-250ml'
					origins: 'my-oil-origins-flavored-garlic-chefs-bottle-250ml'
					certifications: 'certifications'
					made: 'how-its-made-flavored-garlic-evoo-chefs-bottle-250ml'
				}

			# Garlic Glass
			else if title.includes "Garlic EVOO Blend"
				return {
					title: 'Garlic Flavored EVOO'
					flavored: true
					about: 'about-this-oil-flavored-garlic-evoo-glass-bottle-750ml'
					qa: 'qa-flavored-garlic-evoo-glass-bottle-750ml'
					sustainability: 'sustainability-flavored-garlic-evoo-glass-bottle-750ml'
					recipe: 'recipe-flavored-garlic-evoo-glass-bottle-750ml'
					origins: 'my-oil-origins-flavored-garlic-glass-bottle-750ml'
					certifications: 'certifications'
					made: 'how-its-made-flavored-garlic-glass-bottle-750ml'
				}

			# Jalapeño
			else if title.includes "Jalapeno"
				return {
					title: 'Jalapeno Flavored EVOO'
					flavored: true
					about: 'about-this-oil-flavored-jalapeno-herb-evoo-chefs-bottle-250ml'
					qa: 'qa-flavored-jalapeno-evoo-chefs-bottle-250ml'
					sustainability: 'sustainability-flavored-garlic-evoo-chefs-bottle-250ml'
					recipe: 'recipe-flavored-jalapeno-evoo-chefs-bottle-250ml'
					origins: 'my-oil-origins-flavored-jalapeno-herb-evoo--chefs-bottle-250ml'
					certifications: 'certifications'
					made: 'how-its-made-flavored-jalapeno-herb-evoo-chefs-bottle-250ml'
				}

			# Truffle
			else if title.includes "Truffle"
				return {
					title: 'Truffle Flavored EVOO'
					flavored: true
					about: 'about-this-oil-flavored-black-truffle-evoo-chefs-bottle-250ml'
					qa: 'qa-flavored-black-truffle-evoo-chefs-bottle-250ml'
					sustainability: 'sustainability-flavored-black-truffle-evoo-chefs-bottle-250ml'
					recipe: 'recipe-flavored-black-truffle-evoo-chefs-bottle-250ml'
					origins: 'my-oil-origins-flavored-black-truffle-chefs-bottle-250ml'
					certifications: 'certifications'
					made: 'how-its-made-flavored-black-truffle-evoo-chefs-bottle-250ml'
				}

			else if @global
				return {
					flavored: false
					about: 'about-this-oil-global'
					qa: ''
					sustainability: 'sustainability'
					recipe: 'recipe'
					origins: 'my-oil-origins'
					certifications: 'certifications'
					made: 'how-its-made-global'
				}

			else
				return {
					flavored: false
					about: 'about-this-oil-california'
					qa: ''
					sustainability: 'sustainability'
					recipe: 'recipe'
					origins: 'my-oil-origins'
					certifications: 'certifications'
					made: 'how-its-made-california'
				}


		newsletterData: -> @$store.state.globals.newsletter

		computedProduct: -> if @product.length > 0 then return @product

		newsletterBlock: ->
			body: [
				"<h2 class='style-h2'>#{@newsletterData.title}</h2>" if @newsletterData.title
				"<p>#{@newsletterData.description}</p>" if @newsletterData.description
			].join ' '

	methods:

		reset: -> @$emit('reset')

		setNav: (item) -> @current = item

		scrollIntoView: (id) ->
			@$refs[id].scrollIntoView
				behavior: 'smooth'

		updateProduct: (product) ->
			if product? then @product = product

